export const SUBSCRIPTIONS_V3_BASE_URL = `/api/v3/subscriptions/`;
export const SUBSCRIPTIONS_V4_BASE_URL = `/api/v4/mx/subscriptions/`;

export const SUBSCRIPTION_NO_PAYMENT_DETAILS = {
  id: '1',
  external_id: 'varchar[255]',
  created_on: '2025-02-01T12:00:00Z',
  modified_on: '2025-02-01T12:00:00Z',
  customer_id: 'UUID',
  pet_id: 'UUID',
  address_id: 'UUID',
  cadence: 4,
  is_active: true,
  is_grandfathered_meal_plan: false,
  current_order_id: '123',
  current_order: {
    id: '123',
  },
  is_in_billing_period: false,
  next_delivery_target: '2025-03-01',
  shipping_soon_timestamp: '2025-02-28T12:00:00',
  last_edit_datetime: '2025-02-28T12:00:00',
  feeding_guidelines_id: 'UUID',
  mealplan_id: 'UUUID',
  mealplan_cadence_id: 'UUID',
  mealplan_combination_id: 'UUID',
  mealplan_data: {
    plan_type: 'MX',
    plan_type_name: 'mixed',
    percent_of_calories: '1.0',
    plan_metadata: {
      fresh_pack_size: '300',
      fresh_total_packs: '14',
      fresh_packs_per_day: '0.25',
      fresh_calories_per_day: '77.0',
      baked_cups_per_day: '0.25',
      baked_total_bag_weight: '4',
      baked_calories_per_day: '112.5',
      baked_total_bags: '2',
    },
    price_override: '64.90',
    recipe_selections: {
      fresh: ['beef', 'lamb'],
      baked: ['chicken'],
    },
    items: [
      {
        sku: 'MP-BK-CHIC-300',
        qty: 1,
        unit_price: '1.50',
      },
      {
        sku: 'MP-FR-BEEF-300',
        qty: 7,
        unit_price: '4.50',
      },
      {
        sku: 'MP-FR-LAMB-300',
        qty: 7,
        unit_price: '4.20',
      },
    ],
  },
  extras: [
    {
      id: 'UUID',
      sku: 'supplementsskua',
      name: 'supplements a',
      product_id: 'UUID',
      product_code: 'SPPL',
      product_category: 'Supplements',
      is_recommended: true,
      price: '15.00',
      quantity: 1,
      recurrence: 1,
      frequency: 1,
    },
  ],
  extras_in_next_box: [
    {
      id: 'UUID',
      sku: 'supplementsskua',
      name: 'supplements a',
      product_id: 'UUID',
      product_code: 'SPPL',
      product_category: 'Supplements',
      is_recommended: true,
      price: '15.00',
      quantity: 1,
      recurrence: 1,
      frequency: 1,
    },
  ],
};

export const RESPONSE_SUBSCRIPTION = {
  ...SUBSCRIPTION_NO_PAYMENT_DETAILS,
  payment_method: {
    id: 'UUID',
    last_digits: '3366',
    expiry_year: '2030',
    expiry_month: '3',
    brand: 'Visa',
    status: 'PAID',
    type: 'CreditCard',
  },
};

// Error Messages
export const subscriptionId = '123';
export const MX_SUBSCRIPTION_NOT_FOUND_ERROR_MESSAGE = `Subscription with ID ${subscriptionId} was not found`;
